import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const RecognizedEduLevelFilter = ({ label = "l.recognizedEduLevel", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"recognizedEduLevel"} label={label} {...others} />
    </>
  );
};

export default RecognizedEduLevelFilter;
